/**
 * __CONFIGURATION__
 * @namespace
 * @global
 */
const EMPTY_OBJ = {};
// const EMPTY_ARRAY = [];
const configuration = window.__CONFIGURATION__ || EMPTY_OBJ;
delete window.__CONFIGURATION__;

export default Object.freeze(configuration);
